import React, {useState} from 'react';

import {UsePermissions} from "../../hooks/usePermissions";
import {TableContrato} from "./components/TableContrato";
import {Navigate} from "react-router";
import {ModalNuevoContrato} from "./components/ModalNuevoContrato";
import {ArbolClientes} from "./components/ArbolClientes";
import {ModalAsociadoContrato} from "./components/ModalAsociadoContrato";
import {ModalEditarContrato} from "./components/ModalEditarContrato";

export const ContratoPage = () => {
    const [permisos] = UsePermissions();
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayEditModal, setDisplayEditModal] = useState(false);
    const [displayAddUsersModal, setDisplayAddUsersModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);
    const [contratoId, setContratoId] = useState(null);
    const [contrato, setContrato] = useState("");

    const editarContrato= (e) => {
        setFieldEdit({...e});
        setDisplayEditModal(true);
    }

    const crearnuevoContrato = () => {
        setDisplayNewModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }
    const onHideEdit = () => {
        setDisplayEditModal(false);
        setReload(true);
        resetLoad()
    }

    // abrir modla asociados

    const agregarAsociadosContrato = (e) => {
        setContrato(e)
        setDisplayAddUsersModal(true);
    }

    // cerrar modal de asociados
    const onHideEditUser = () => {
        setDisplayAddUsersModal(false);
    }

    const resetLoad = () => {
        setTimeout(() =>{
            setReload(false);
        }, 2000)
    }


    const onLoadChildren = (e) => {
        setContratoId(e);
    }
    return (
        <>
            <div className="flex flex-wrap">
                <div className="w-full lg:w-3/12 px-4">
                    <div className="container-relative">
                        <ArbolClientes children={onLoadChildren} />
                    </div>
                </div>
                <div className="w-full lg:w-9/12 px-4">
                    <div className="container-relative">
                        {permisos.consultar ? <TableContrato reload={reload} obtenerParametrosContrato={editarContrato} nuevoContrato={crearnuevoContrato} contrato={contratoId} asociadosContrato={agregarAsociadosContrato} />:  <Navigate to="/home"/>}
                        <ModalNuevoContrato show={displayNewModal} hide={onHide}/>
                        <ModalEditarContrato show={displayEditModal} fields={fieldEdit} hide={onHideEdit}/>
                        <ModalAsociadoContrato show={displayAddUsersModal} hide={onHideEditUser} contrato={contrato} />
                    </div>
                </div>

            </div>
        </>
    );
};

